import React from "react";
import Grid from "@mui/material/Grid/Grid";
import { ProductCard } from "../product-card/product-card";
import styles from "./products-container.module.scss";

interface Props {
  products: any[];
}

const ProductsContainer: React.FC<Props> = ({ products }) => {
  return (
    <div className={styles.container}>
      <Grid container rowSpacing={4} columnSpacing={2}>
        {products.map((product: any, index) => (
          <Grid item xs={12} sm={12} md={12 / 2} lg={12 / 2} key={index}>
            <ProductCard data={product} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ProductsContainer;
